import { render } from "./article-info.vue?vue&type=template&id=2a570c84"
import script from "./article-info.vue?vue&type=script&lang=js"
export * from "./article-info.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__